module.exports = __webpack_public_path__ + "img/SHOrganizationManage.860fc2a4.svg";